// extracted by mini-css-extract-plugin
export default {"card":"Card_card__4f4G2"};